export default [
  {id: 1, codigo: 'ASININOS', label: 'Asininos', showTipo: true},
  {id: 2, codigo: 'AVES', label: 'Aves', showTipo: true},
  {id: 3, codigo: 'BOVINOS', label: 'Bovinos', showTipo: true},
  {id: 4, codigo: 'BUBALINOS', label: 'Bubalinos', showTipo: true},
  {id: 5, codigo: 'CAPRINOS', label: 'Caprinos', showTipo: true},
  {id: 6, codigo: 'EQUINOS', label: 'Equinos', showTipo: true},
  {id: 7, codigo: 'MUARES', label: 'Muares', showTipo: true},
  {id: 8, codigo: 'SUINOS', label: 'Suinos', showTipo: false},
  {id: 9, codigo: 'OVINOS', label: 'Ovinos', showTipo: false},
  {id: 10, codigo: 'OUTROS', label: 'Outros', showTipo: true}
]



// WEBPACK FOOTER //
// ./src/utils/tipoSemoventes.js